export const cameraView04BoatNameImageOptions = {
  legacy: true,
  prefix: 'X4_9_Exterior',
  angle: 'Camera View 04 - Boat name',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    TeakOnBathingPlatform: 1,
    Boom: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/CameraView04BoatName.js